window.groupTree = function ($) {
    var checkedvalues = "";
    var existchechedvalues = "";
    var lastFocus = "";
    var instance = {
        checkboxClick: function(checkBoxId) {
            const explId = checkBoxId.split("_check_");
            const checkBox = document.querySelector("#" + checkBoxId); 
            const inputRights = document.querySelector("#" + explId[0] + "_rchecked");
            const explValue = explId[1] + ";";

            if (checkBox.checked) {
                if (!inputRights.value.includes(explValue)) {
                    inputRights.value += explValue;
                }
                if (!checkedvalues.includes(explValue)) {
	                checkedvalues += explValue;
                }
            } else {
                if (inputRights.value.includes(explValue)) {
                    inputRights.value = inputRights.value.replace(explValue, "");                    
                }
                if (checkedvalues.includes(explValue)) {
                    checkedvalues = checkedvalues.replace(explValue, "");                    
                }
            }
        },

        checkboxExistClick: function (checkBoxId) {
	        const explId = checkBoxId.split("_existcheck_");
	        const checkBox = document.querySelector("#" + checkBoxId);
            const inputRights = document.querySelector("#" + explId[0] + "_existchecked");
	        const explValue = explId[1] + ";";

	        if (checkBox.checked) {

		        if (inputRights.value.includes(explValue)) {
			        inputRights.value = inputRights.value.replace(explValue, "");
		        }
		        if (existchechedvalues.includes(explValue)) {
			        existchechedvalues = existchechedvalues.replace(explValue, "");
		        }
            } else {
		        if (!inputRights.value.includes(explValue)) {
			        inputRights.value += explValue;
		        }
		        if (!existchechedvalues.includes(explValue)) {
			        existchechedvalues += explValue;
		        }
	        }
        },

        pageClick: function(inputId) {
            const inpBox = document.querySelector("#" + inputId);
            if (!checkedvalues.includes(inpBox.value)) {
                checkedvalues += inpBox.value;
            }
        },

        pageExistClick: function (inputId) {
	        const inpBox = document.querySelector("#" + inputId);
            if (!existchechedvalues.includes(inpBox.value)) {
	            existchechedvalues += inpBox.value;
	        }
        },

        clearValues: function() {
            checkedvalues = "";
            existchechedvalues = "";
        },

        focusedInput: function(inputId) {
            lastFocus = "#" + inputId;
        },

        widgetDidMount: function(state) {
            const inpBox = document.querySelector("#" + state.root + "_rchecked");
            if (inpBox != null) {
                if (!inpBox.value.includes(checkedvalues)) {
                    inpBox.value += checkedvalues;
                }
            }

            const values = checkedvalues.split(";");
            values.forEach(function(element) {
                const chBox = document.querySelector("#" + state.root + "_check_" + element);
                if (chBox != null) {
                    chBox.checked = true;
                }
            });

            if(lastFocus) {
                const focusedBox = document.querySelector(lastFocus);
                if(focusedBox != null) {
                    focusedBox.focus();
                }
            }

            const existInpBox = document.querySelector("#" + state.root + "_existchecked");
            if (existInpBox != null) {
	            if (!existInpBox.value.includes(existchechedvalues)) {
                    existInpBox.value += existchechedvalues;
	            }
            }
        }
    };
    return instance;
}();